import React, { PropTypes } from 'react';
import { DropdownButton } from 'react-bootstrap';
import _ from 'lodash';

import NavBar from './NavBar';
import NavLink from './NavLink';
import * as ROLE from '../constants/roles';
import HighestDropboxRoleSelector from '../selectors/HighestDropboxRoleSelector';

const HeaderLinks = ({ auth, roles_self } ) => {
    return (
        <NavBar
            className="header-links navbar navbar-toggleable-md navbar-inverse bg-inverse fixed-top"
            useLoadingBar
            useToggler
            showBrand
            collapse
        >
            <NavLink
                to="/"
                className ="nav-link"
                side="left"
                display
                key="home"
                onlyActiveOnIndex={true}
            >
                Home
            </NavLink>
            <NavLink
                to="/logs"
                className ="nav-link"
                side="left"
                display={
                    location.pathname === '/logs' ||
                    (   _.includes(
                            [ ROLE.ADMIN, ROLE.INSTRUCTOR ],
                            HighestDropboxRoleSelector({ roles: roles_self })
                        )
                    )
                }
                key="logs"
            >
                Logs
            </NavLink>
            <NavLink
                to="/login"
                className="nav-link"
                side="right"
                display={!auth.isAuthenticated}
                key="login"
            >
                Login
            </NavLink>
            <NavLink
                to={null}
                id={"menu_username"}
                side="right"
                display={auth.isAuthenticated}
                key="username"
                dropdown={
                    auth.isAuthenticated
                    ? (
                        <li className="nav-item">
                            <DropdownButton
                                id="menu_username"
                                title={`Logged in as ${auth.username}`}
                                className="nav-link bg-inverse navbar-inverse"
                            >
                                <a
                                    href="/logout"
                                    role="menuitem"
                                    tabIndex="-1"
                                    className="dropdown-item"
                                >
                                    Logout
                                </a>
                            </DropdownButton>
                        </li>
                    ) : null
                }
            />
            <NavLink
                to="https://csguide.cs.princeton.edu/academic/tigerfile"
                target="_blank"
                className ="nav-link"
                side="right"
                display
                key="help"
            >
                Help
            </NavLink>
        </NavBar>
    );
};


HeaderLinks.propTypes = {
    auth: PropTypes.object.isRequired,
    roles_self: PropTypes.object.isRequired,
};

export default HeaderLinks;


/** WEBPACK FOOTER **
 ** ./src/components/HeaderLinks.js
 **/